import { render } from "./visaCenterList.vue?vue&type=template&id=31a95597&scoped=true"
import script from "./visaCenterList.vue?vue&type=script&lang=js"
export * from "./visaCenterList.vue?vue&type=script&lang=js"

import "./visaCenterList.vue?vue&type=style&index=0&id=31a95597&lang=scss&scoped=true"

import exportComponent from "/Users/xirc/project/项目/chuanmeidaxue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31a95597"]])

export default __exports__